import { Grid, Card, CardContent, Typography, Stack, Chip, Box } from "@mui/material"
import UserContextP from "Interfaces/Context"
import { useContext } from "react"

interface PropsInterface {
    order: any
    costumer: any
    color: string
}

const Header = (props: PropsInterface) => {
    const { order, costumer, color } = props
    const context = useContext(UserContextP)

    const currency = process.env.REACT_APP_CURRENCY ?? '$'
    const formatMoney = (value: number) => `${currency} ${context.separatorMiles(value ?? 0)}`

    return (
        <>
            {/* Company / Commercial name */}
            <Grid item xs={12} md={6}>
                <Card elevation={0} sx={{ borderRadius: 1, borderLeft: `4px solid ${color}` }}>
                    <CardContent>
                        <Typography variant="caption" color="text.secondary">Razón social</Typography>
                        <Typography variant="h6" sx={{ mt: 0.5 }}>{costumer?.CardName ?? '—'}</Typography>
                        <Typography variant="body2" color="text.secondary">Código: {costumer?.CardCode ?? order?.cardCode ?? '—'}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} md={6}>
                <Card elevation={0} sx={{ borderRadius: 1, borderLeft: `4px solid ${color}` }}>
                    <CardContent>
                        <Typography variant="caption" color="text.secondary">Nombre Comercial</Typography>
                        <Typography variant="h6" sx={{ mt: 0.5 }}>{costumer?.CardFName ?? '—'}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Financial summary: balance and credit */}
            <Grid item xs={12} md={6}>
                <Card elevation={0} sx={{ borderRadius: 1, borderLeft: `4px solid ${color}` }}>
                    <CardContent>
                        <Typography variant="caption" color="text.secondary">Saldo pendiente</Typography>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
                            <Chip label={formatMoney(costumer?.Balance ?? 0)} color="default" sx={{ bgcolor: '#fff3e0' }} />
                            <Typography variant="body2" color="text.secondary">Disponible: {formatMoney((costumer?.CreditLine ?? 0) - (costumer?.Balance ?? 0))}</Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} md={6}>
                <Card elevation={0} sx={{ borderRadius: 1, borderLeft: `4px solid ${color}` }}>
                    <CardContent>
                        <Typography variant="caption" color="text.secondary">Límite de crédito</Typography>
                        <Typography variant="h6" sx={{ mt: 0.5 }}>{formatMoney(costumer?.CreditLine ?? 0)}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Address */}
            <Grid item xs={12}>
                <Card elevation={0} sx={{ borderRadius: 1, borderLeft: `4px solid ${color}` }}>
                    <CardContent>
                        <Typography variant="caption" color="text.secondary">Dirección</Typography>
                        <Box sx={{ mt: 0.5 }}>
                            <Typography variant="body1">{order?.street && order?.street !== '' ? order.street : 'No posee dirección'}</Typography>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}

export default Header